import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FoundationProject } from '@models';

@Component({
  selector: 'lfx-dev-analytics-summary',
  templateUrl: './dev-analytics-summary.component.html',
  styleUrls: ['./dev-analytics-summary.component.scss'],
})
export class DevAnalyticsSummaryComponent {
  @Input() projects: FoundationProject[];
  @Input() contributors: number;
  @Input() contributions: number;
  @Input() chartColor: string;
  @Output() hoverEvent = new EventEmitter();

  selectedStatistics = 'all';

  constructor() {}

  onMouseOver(value) {
    this.selectedStatistics = value;
    this.hoverEvent.emit(this.selectedStatistics);
  }

  onMouseLeave() {
    this.selectedStatistics = 'all';
    this.hoverEvent.emit(this.selectedStatistics);
  }
}
